export const GET_CHANGE_LOG = "GET_CHANGE_LOG";
export const SET_CHANGE_LOG = "SET_CHANGE_LOG";

export const DOWNLOAD_CHANGE_LOG_CSV = "DOWNLOAD_CHANGE_LOG_CSV";
export const DOWNLOAD_CHANGE_LOG_CSV_RESPONSE = "DOWNLOAD_CHANGE_LOG_CSV_RESPONSE";
